import Vue from "vue";
import VueI18n from "vue-i18n";
import en from './en'
import cn from './cn'
import de from './de'
import es from './es'
import fr from './fr'
import it from './it'
import ja from './ja'
import ko from './ko'
import pt from './pt'

Vue.use(VueI18n); // 全局挂载

export const i18n = new VueI18n({
    locale: localStorage.getItem("locale") || "en", // 从localStorage中获取 默认英文
    messages: {
      en,
      cn,
      de,
      es,
      fr,
      it,
      ja,
      ko,
      pt
    },
    silentTranslationWarn:true
  });
   
  export default i18n;